/* ============================= E X P O R T ============================= */

export default {
  name: 'Edit',

  props: {
    color: {
      type: String,
      in: [
        'primary',
        'secundary'
      ]
    }
  }
}
